$(document).ready(function () {
  // ------------------- TB_category_featured Start -------------------
  var TB_category_featured = $(document).ready(function () {
            $("#TB-category-featured .owl-carousel").owlCarousel({
                items: 6,
                loop: false,
                dots: false,
                margin: 0,
                autoplay: true,
                autoplayTimeout: 4000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    576: {
                        items: 2,
                    },
                    992: {
                        items: 3,
                    },
                    1200: {
                        items: 4,
                    },
                    1500: {
                        items: 5,
                    },
                    1700: {
                        items: 6,
                    }
                },
            });
        });
  // ------------------- TB_category_featured End -------------------

  // ------------------- TB_service_cms Start -------------------
  $("#TB-service-cms .owl-carousel").owlCarousel({
    items: 6,
    loop: false,
    dots: false,
    margin: 40,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      576: { items: 2 },
      992: { items: 3 },
      1200: { items: 4 },
      1400: { items: 5 },
      1600: { items: 6 }
    }
  });
// ------------------- TB_service_cms End -------------------
});
